export enum RegistrationGaCategory {
  Pages = 'registration-pages',
}
